var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnnouncementOutFocus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 30,
    viewBox: "0 0 27 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.8 21.15C26.1 21.6 26.4 22.05 26.4 22.5C26.4 22.95 26.25 23.4 25.8 23.85C25.5 24.15 25.05 24.45 24.45 24.45H1.95C1.35 24.45 0.9 24.3 0.6 23.85C0.3 23.55 0 23.1 0 22.5C0 21.9 0.15 21.6 0.6 21.15L0.75 21C1.65 20.1 2.25 19.2 2.7 18.3C3.45 16.8 3.75 14.7 3.75 12.3C3.75 10.05 4.5 8.1 5.85 6.45C7.2 4.8 9 3.75 11.25 3.3V1.8C11.25 1.35 11.4 0.9 11.85 0.45C12.3 0 12.75 0 13.2 0C13.65 0 14.1 0.15 14.55 0.6C15 1.05 15.15 1.35 15.15 1.95V3.15C17.4 3.6 19.2 4.65 20.55 6.3C21.9 7.95 22.65 9.9 22.65 12.15C22.65 14.55 22.95 16.65 23.7 18.15C24.15 19.05 24.75 19.95 25.65 20.85C25.65 21.15 25.8 21.15 25.8 21.15ZM4.05 21.6H22.35C20.7 19.35 19.8 16.2 19.8 12.3C19.8 11.1 19.5 10.05 18.9 9C18.3 7.95 17.55 7.2 16.5 6.6C15.45 6 14.4 5.7 13.2 5.7C12 5.7 10.95 5.85 9.9 6.45C8.85 7.05 8.1 7.95 7.5 8.85C6.9 9.75 6.6 10.95 6.6 12.15C6.6 16.2 5.85 19.2 4.05 21.6ZM13.2 30C12.15 30 11.25 29.7 10.5 28.95C9.75 28.2 9.45 27.3 9.45 26.25H16.95C16.95 27.3 16.65 28.2 15.9 28.95C15.15 29.7 14.25 30 13.2 30Z",
    fill: "#A1A1A1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnnouncementOutFocus);
export default __webpack_public_path__ + "static/media/announcement-out-focus.b5cd9c6088a576cf3cbe2be244108cd4.svg";
export { ForwardRef as ReactComponent };